import { render, staticRenderFns } from "./statsBudgetsCounters.vue?vue&type=template&id=d68e9106&"
import script from "./statsBudgetsCounters.vue?vue&type=script&lang=js&"
export * from "./statsBudgetsCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports